import * as React from 'react';
import { Button, styled, Tooltip, tooltipClasses } from '@mui/material';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Info } from 'react-feather'

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export const TooltipInformation = (props) => {

    const {
        usuario_creo, 
        fecha_creo, 
        usuario_modifico, 
        fecha_modifico 
    } = props

    return (
        <>
            <HtmlTooltip
                title={
                    <>
                        <b>Usuario Creo:</b> {usuario_creo}
                        <br></br>
                        <b>Fecha Creo:</b> {fecha_creo}
                        <br></br>
                        <b>Usuario Modifico:</b> {(usuario_modifico != null ? usuario_modifico : '')}
                        <br></br>
                        <b>Fecha Modifico:</b> {(fecha_modifico != null ? fecha_modifico : '')}
                    </>
                }
            >
                <Button style={{ color: '#6c757d' }}>
                    <Info />
                </Button>
            </HtmlTooltip>
        </>
    )
}
